/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";

import { useDispatch, useSelector } from "react-redux";

import Sidebar from "../../components/dashboard/SideBar";

import {
  gettingBioLink,
  resetLink,
} from "../../redux/slices/getLink/getLinkSlice";
import { creatingBioLink } from "../../redux/slices/bioLink/bioLinkSlice";
import {
  logoutUser,
  resetUser as resetAuthUser,
} from "../../redux/slices/auth/authSlice";
import {
  gettingLinkList,
  resetLinkList,
} from "../../redux/slices/gettingLinksList/gettingLinkListSlice";
import { clearEmails } from "../../redux/slices/InvitationSystem/InvitationSlice";
import { toast } from "react-hot-toast";
import LogoutConfirmModal from "../../components/dashboard/modal/LogoutConfirm";
import LoadingScreen from "../../components/dashboard/LoadingScreen";

// main dashboard layout, It will render pages with sidbar

const SideBarLayout = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // getting User detail
  const user = localStorage.getItem("user")
    ? JSON.parse(localStorage.getItem("user"))
    : null;

  const viewUserisLoading = useSelector(
    (state) => state?.adminUser?.viewUserisLoading
  );

  const getLinkState = useSelector((state) => state?.gettingBioLinksState);

  const handleAdminLogout = () => {
    dispatch(logoutUser());
    dispatch(resetLinkList());
    dispatch(resetAuthUser());
    dispatch(clearEmails());
    navigate("/auth/login");
  };

  useEffect(() => {
    dispatch(gettingBioLink());
    dispatch(resetLink());
    setTimeout(() => {
      createBioLink();
    }, 5000);
  }, []);
  const createBioLink = async () => {
    if (!getLinkState?.getBioLinkLoading) {
      if (!localStorage.getItem("linkId")) {
        // toast.error("Bio Link not found");
        const CreatedBioLinkData = {
          tag: "main",
          registeredUserID: user.userid,
        };
        await dispatch(creatingBioLink(CreatedBioLinkData));
        handleAdminLogout();
      } else {
        fetchingLinkList();
      }
    }
  };
  const fetchingLinkList = async () => {
    // const linkId = getLinktate?.getBioLink?.response?.[0]?._id;
    const linkId =
      localStorage.getItem("linkId") ||
      getLinkState?.getBioLink?.response?.[0]?._id;
    const user = JSON.parse(localStorage.getItem("user"));
    const userId = user.userid;
    const usertoken = user.token;
    const linkListData = {
      userId,
      usertoken,
      linkId,
    };
    if (linkId) {
      await dispatch(gettingLinkList(linkListData));
      dispatch(resetLinkList());
    }
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const handleDeleteModal = () => {
    handleAdminLogout();
    setIsModalOpen(false);
  };
  const mylinkstate = useSelector((state) => state?.linkList || []);
  const { getBlockByPlanIdLoading } = useSelector(
    (state) => state?.paymentStripes
  );
  // { getBlockByPlanIdLoading ?
  //   <LoadingScreen /> :
  //     <>
  // || mylinkstate?.getLinkList?.linkListLoading || getLinkState?.getBioLinkLoading
  return (
    <>
      {viewUserisLoading || getBlockByPlanIdLoading ? (
        <LoadingScreen />
      ) : (
        <div className=" flex flex-col md:flex-row relative">
          <LogoutConfirmModal
            isOpen={isModalOpen}
            onCancel={() => setIsModalOpen(false)}
            onConfirm={handleDeleteModal}
          />
          <div className="w-[93px] fixed hidden md:block sidebar  bg-white dark:bg-dark-secondary">
            <Sidebar handleAdminLogout={() => setIsModalOpen(true)} />
          </div>
          <div className={"md:ms-[93px] w-full overflow-hidden"}>
            <div className="min-h-screen">
              <Outlet />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default SideBarLayout;
